import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './ds/tokens.css';
import './ds/bundle.css';
import './styles.css';
import { App } from './App';
// after the screens' own sheets, so the shared chrome wins where they overlap
import './ui/chrome.css';
import { startInstall } from './lib/install';
import { unlockOnFirstTap } from './lib/sound';
import { registerServiceWorker } from './lib/sw';
import { Crash } from './ui/Crash';

unlockOnFirstTap();
registerServiceWorker();
// the browser's install offer comes once and early: kept for the install bar and Get the app
startInstall();

const root = document.getElementById('root');
if (root) {
  createRoot(root).render(
    <StrictMode>
      <Crash>
        <App />
      </Crash>
    </StrictMode>,
  );
}
